import { Stack, Title } from '@mantine/core';
import type { FC, ReactElement } from 'react';

import { Panel } from '../global/Panel/Panel.tsx';
import { CenterLayout } from './CenterLayout.tsx';

interface BaseProps {
  heading: string;
  bodyContent: ReactElement;
}

interface ProgressProps extends BaseProps {
  progress: {
    currentStep: number;
    totalSteps: number;
  };
  customTopTitle?: never;
}

interface CustomTopTitleProps extends BaseProps {
  progress?: never;
  customTopTitle?: string;
}

type OnboardStepProps = ProgressProps | CustomTopTitleProps;

export const FlowStep: FC<OnboardStepProps> = ({ progress, heading, bodyContent, customTopTitle }) => (
  <CenterLayout>
    <Panel>
      <Stack gap="xxxs">
        {progress && (
          <Title c="grape" order={5} ta="center">
            Step {progress.currentStep} / {progress.totalSteps}
          </Title>
        )}
        {customTopTitle && (
          <Title c="grape" order={4} ta="center">
            {customTopTitle}
          </Title>
        )}
        <Title order={2} ta="center">
          {heading}
        </Title>
      </Stack>
      {bodyContent}
    </Panel>
  </CenterLayout>
);
